<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1"><i>To the memory of Dr. William Carlos Williams,</i> <br/><i>whose words and thoughts inspired and</i> <br/><i>helped so many of us in medicine;</i> <br/><i>and to my family with much love.</i></div>
<div class="ctag1">—ROBERT COLES</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// robe_9781595587800_oeb_ded_r1.vue?1f445598